/* eslint 'no-redeclare': 'off', eqeqeq: 'off' */
import React, { Component } from "react";
import { Table, Button, Modal } from "reactstrap";
import { connect } from "react-redux";
import '../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../Assets/EnsembleStyles/WorkOrders.css';
import ErrorGif from '../../../Assets/images/Error.gif';
import classnames from 'classnames';
import * as ErrorMessage from '../../../Resources/ErrorMessages';
import SelectAllCheckboxes from '../../../Resources/SelectAllCheckboxes';
import DeleteConfirmation from './_ModalsForms/WorkOrderDeleteConfirmation';
import { makeGetCall, DeleteTenants } from '../../../action/tenantAction';
import { ChangeDisplayinWorkOrderTenant } from '../../../action/workorderAction';
import { createFilter } from 'react-search-input';
import TenantDetails from './_ModalsForms/TenantDetails';
import TenantAssociation from './_ModalsForms/TenantAssociation';
import ReactPaginate from 'react-paginate';
import LoadingIndicator from '../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['tenantName', 'address'];
let pagesCount = 0;
class WorkorderTenantList extends Component {
    componentWillMount() {
        this.props.makeGetCall().then(() => {this.setState({isloading:false})});
    }
    componentWillUnmount(){
        this.props.ChangeDisplayinWorkOrderTenant('TenantList');
    }
    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({
                Display: nextProps.Tenant_DisplayState_Response.page_to_display_tenant,
                AssociateTenantID: nextProps.Tenant_To_Display.tenant_to_associate
            });
            if(nextProps.Tenant_To_Display.tenant_to_associate === 'TenantDetails'){
                var lTenant_Data = this.props.getResponse.TenantsList;
                if (lTenant_Data != undefined && lTenant_Data != null && lTenant_Data.length > 0) {
                    var lTenant = lTenant_Data.filter(el => el.tenantId == nextProps.Tenant_To_Display.tenant_to_associate);
                    this.setState({
                        IsEdit: true,
                        TenantDetails: lTenant[0] !== undefined ? lTenant[0] : []
                    });
                }
            }
            var el = document.getElementsByClassName('tab-pane active'); 
            el[0].scrollTop = 0;
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            error_msg: false,
            deletemodal: false,
            IsEdit: false,
            sort: {
                column: null,
                direction: [
                    { name: 'tenantName', direction: 'asc', onclick: true },
                    { name: 'address', direction: 'desc', onclick: false },
                    { name: 'OpenWO', direction: 'desc', onclick: false }
                ]
            },
            searchTerm: "",
            TenantDetails: [],
            Display: 'TenantList',
            AssociateTenantID: 0,
            AssociateTenantName: [],
            currentPage: 0,
            pageSize: 50,
            IsDefaultSort: true
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    /* Pagination System */
    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    };

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.tenant_search_value.value })
    }

    /* Sorting  System */
    onSortNumber = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getResponse.TenantsList;
        var workorder_from_state = this.props.getWorkOrderList.WorkOrderList;
        if (data_from_state != null) {
            var sortedData = [];
            if (column === "OpenWO") {
                sortedData = data_from_state.sort((a, b) => {
                    var OpenWO1 = [], OpenWO2 = [];
                    if (workorder_from_state !== undefined && workorder_from_state !== null && workorder_from_state.length > 0) {
                        OpenWO1 = workorder_from_state.filter(ele => ele.workOrderDetail.tenantID == a["tenantId"] && (ele.status === 1 || ele.status === 2))
                        OpenWO2 = workorder_from_state.filter(ele => ele.workOrderDetail.tenantID == b["tenantId"] && (ele.status === 1 || ele.status === 2))
                    }
                    return (OpenWO1.length - OpenWO2.length);
                });
            } else {
                sortedData = data_from_state.sort((a, b) => {
                    let nameA = a[column];
                    let nameB = b[column];
                    return (nameA - nameB);
                });
            }
            if (direction === 'desc') {
                sortedData.reverse();
            }
            if (selected[0].name == "OpenWO") {
                SortData[2].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "OpenWO") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            this.props.getResponse.TenantsList = sortedData;
            this.setState({
                sort: { column, direction: SortData }
            });
        }
    };

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getResponse.TenantsList;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column].toLowerCase();
                let nameB = b[column].toLowerCase();

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }

            if (selected[0].name == "tenantName") {
                SortData[0].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "tenantName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "address") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "address") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }

            this.props.getResponse.TenantsList = sortedData;
            this.setState({
                sort: { column, direction: SortData }
            });
        }
    };

    ViewtenantDetails(TenantData) {
        this.setState({
            IsEdit: true, 
            AssociateTenantID: TenantData.tenantId,
            AssociateTenantName: TenantData.tenantName,
            TenantDetails: TenantData,
            error_msg: false
        });
        this.props.ChangeDisplayinWorkOrderTenant('TenantDetails');
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    DeleteTenants() {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('WorkOrderTenantRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
                break;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }

    /* Delete Confirmation*/
    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('WorkOrderTenantRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var tenant_id_to_be_deleted = {
                        "tenantId": checkboxes[i].id
                    }
                    Data.push(tenant_id_to_be_deleted);
                }
            }
            this.props.DeleteTenants(Data);
        }
        this.Deletetoggle();
    }

    CreateNewTenant() {
        this.setState({IsEdit : false, error_msg: false});
        this.props.ChangeDisplayinWorkOrderTenant('TenantDetails');
    }

    render(getLabels, getResponse, getWorkOrderList) {
        let Tenants, Tenant_Data, WorkOrder_Data, Error_Message = null;
        let lTenantlength = 0, lCurrentTenantlength = 0;
        let label = this.props.getLabels;
        Tenant_Data = this.props.getResponse.TenantsList;
        WorkOrder_Data = this.props.getWorkOrderList.WorkOrderList;
        if (Tenant_Data != undefined && Tenant_Data != null && Tenant_Data.length > 0 && !this.state.isloading) {
            
            if(this.state.IsDefaultSort){
                //eslint-disable-next-line
                let sortedData = Tenant_Data.sort((a, b) => {
                    let nameA = a['tenantName'].toLowerCase();
                    let nameB = b['tenantName'].toLowerCase();
    
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                });
            }

            let FilteredData = Tenant_Data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lTenantlength = FilteredData.length;
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            Tenants = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
            ).map(el => {
                var OpenWO = [];
                if (WorkOrder_Data !== undefined && WorkOrder_Data !== null && WorkOrder_Data.length > 0) {
                    OpenWO = WorkOrder_Data.filter(ele => ele.workOrderDetail.tenantID == el.tenantId && (ele.status === 1 || ele.status === 2))
                }
                return <tr key={el.tenantId}>
                    <td width="5%"><input type="checkbox" id={el.tenantId} className="WorkOrderTenantRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("WorkOrderTenantRows", "WOTenant_header_Check_box"); }} /></td>
                    <td width="25%"><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ViewtenantDetails(el) }} >{el.tenantName}</p></td>
                    <td width="30%">{el.address}</td>
                    <td width="20%">{OpenWO.length}</td>
                </tr>
            }) : <tr><td colSpan="5">{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr> ;
            if(Tenants.length !== undefined)
                lCurrentTenantlength = Tenants.length;
        } else if(!this.state.isloading) {
            Tenants = <tr><td colSpan="5">{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
        } else{
            Tenants = <tr><td colSpan="5" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error_alt}</p> : Error_Message = "";
        
        return (
            this.state.Display === 'TenantDetails' ? <TenantDetails IsEdit={this.state.IsEdit} TenantDetails={this.state.TenantDetails}  Premise={this.props.Premise}/> :
            this.state.Display === 'TenantAssociation' ? <TenantAssociation AssociaTetenantId={this.state.AssociateTenantID} AssociateTenantName={this.state.AssociateTenantName}/> :
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
             <div className="border_container">
             <div className="main_container">
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                    <div className="col-md-12">
                        {Error_Message}
                    </div>
                </div>
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                    <div className="col-md-12">
                        <label className="child_tab_paginationtext">{(lTenantlength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentTenantlength) + " of " + lTenantlength + " records"}</label>
                        <Button className="child_tab_button_template" style={{ 'width':'143px', 'margin-left': '8px'}} onClick={() => { this.CreateNewTenant() }} >{label['WorkOrders.CreateNewTenant.Text'] !== undefined ? label['WorkOrders.CreateNewTenant.Text'] : "Create New Tenant"}</Button>
                        <Button className="btn-black" onClick={() => { this.DeleteTenants() }}>{label['WorkOrders.DeleteTenant.Text'] !== undefined ? label['WorkOrders.DeleteTenant.Text'] : "DELETE"}</Button>
                        <span className="pm_outersearchbox" style={{ float: 'right' }}>
                            <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='tenant_search_value' />
                        </span>
                        <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                    </div>
                </div>
                <br/>
                <div className="table_container table_border" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
                    <Table striped responsive className="Custom_table">
                        <tbody  className="cell_container">
                            <tr>
                                <th><input type="checkbox" className="WOTenant_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("WorkOrderTenantRows", "WOTenant_header_Check_box"); }} /></th>
                                <th onClick={this.onSort('tenantName')} className="wo_cursor">
                                    <span>{label['WorkOrders.Tenants.TenantName.Text'] !== undefined ? label['WorkOrders.Tenants.TenantName.Text'] : "TENANT NAME"}</span>
                                    <span className={(this.state.sort.direction[0].name == "tenantName") ?
                                        (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('address')} className="wo_cursor">
                                    <span>{label['WorkOrders.Tenants.Address.Text'] !== undefined ? label['WorkOrders.Tenants.Address.Text'] : "ADDRESS"}</span>
                                    <span className={(this.state.sort.direction[1] !== undefined && this.state.sort.direction[1].name == "address") ?
                                        (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSortNumber('OpenWO')} className="wo_cursor">
                                    <span>{label['WorkOrders.Tenants.OpenWO.Text'] !== undefined ? label['WorkOrders.Tenants.OpenWO.Text'] : "OPEN WOs"}</span>
                                    <span className={(this.state.sort.direction[2] !== undefined && this.state.sort.direction[2].name == "OpenWO") ?
                                        (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                            </tr>
                            {Tenants}
                        </tbody>
                    </Table>
                </div>
                <div className="row row_padding pm_pagination" style={{'margin-right':'15px'}}>
                    <div className="col-md-7">
                        <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me pagination_margin'}
                        breakLinkClassName={'pagination_link_color'}
                        pageCount={pagesCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination pagination_container_margin'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        disabledClassName={'pagination_disable_link'}
                        pageClassName={'pagination_margin'}
                        pageLinkClassName={'pagination_link_color'}
                        previousClassName={'pagination_margin'}
                        previousLinkClassName={'pagination_link_color'}
                        nextClassName={'pagination_margin'}
                        nextLinkClassName={'pagination_link_color'}
                        forcePage={this.state.currentPage}
                        />
                    </div>
                </div>
                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Tenant", "You are about to delete a tenant from the system. Do you want to continue?", "Close Window", "Delete Tenant"]} Delete={this.Delete} />
                </Modal>
                </div>
                </div>
            </div>
        );
    }
};
const mapStateToProps = state => {
    return {
        getResponse: state.tenantsRootReducer,
        getWorkOrderList: state.WorkorderRootReducer,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        Tenant_DisplayState_Response: state.WorkorderRootReducer.WorkOrderTenantDisplay,
        Tenant_To_Display: state.WorkorderRootReducer.TenantToAssociate
    };
};
const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        DeleteTenants: (data) => dispatch(DeleteTenants(data)),
        ChangeDisplayinWorkOrderTenant: (data) => dispatch(ChangeDisplayinWorkOrderTenant(data))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkorderTenantList);